import React from 'react'
import { Redirect } from 'react-router-dom'

import { DashboardRoute } from 'routes/config'

export default () => (
  <Redirect to={ DashboardRoute.path } />
)



// WEBPACK FOOTER //
// ./src/pages/index.js